export const GAME_FIELD_COLUMNS = 5;

export const GAME_FIELD_ROWS = 10;

export const GAME_FIELD_COUNT_CELLS = GAME_FIELD_COLUMNS * GAME_FIELD_ROWS;

export const ONBOARDING_STEPS = {
	GAME_FIELD: 'game-field',
	BET_MENU: 'bet-menu',
	WAGER_FIELD: 'wager-field',
	BET_CALCULATOR: 'bet-calculator',
	BET_BUTTON: 'bet-button',
} as const satisfies Record<string, string>;

export const ONBOARDING_STEPS_MOBILE = {
	GAME_FIELD: ONBOARDING_STEPS.GAME_FIELD,
	WAGER_FIELD: ONBOARDING_STEPS.WAGER_FIELD,
	BET_CALCULATOR: ONBOARDING_STEPS.BET_CALCULATOR,
	BET_BUTTON: ONBOARDING_STEPS.BET_BUTTON,
};

export const ONBOARDING_STEPS_DESKTOP = {
	GAME_FIELD: ONBOARDING_STEPS.GAME_FIELD,
	BET_MENU: ONBOARDING_STEPS.BET_MENU,
	BET_BUTTON: ONBOARDING_STEPS.BET_BUTTON,
};

export type OnboardingStep = (typeof ONBOARDING_STEPS)[keyof typeof ONBOARDING_STEPS];
